import React from 'react';
import { environment } from '../lib/RelayUtils';
import { QueryRenderer } from 'react-relay';

export const createQueryRenderer = (Component, config) => {
	const { query, variables = {}, props: spreadProps} = config;
	return () => (
		<QueryRenderer
			variables={variables}
			query={query}
			environment={environment}
			render={({ error, props }) => {
				if (error && error.res.status === 401) {
					return null;
				}

				if (error) {
					return <div>{error.message}</div>;
				} else if (!props) {
					return <div>Loading</div>;
				}

				return <Component query={props} {...spreadProps} />;
			}}
		/>
	);
};



// WEBPACK FOOTER //
// src/relay/createQueryRenderer.jsx